<!-- //
侧边树组件，添加
@auth xuyd
@date 2024-05-01
//-->
<template>
  <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="100px">
    <el-row class="flow-row">
      <el-form-item prop="parentId" label="父级分组">
        <TreeSelect v-model="form.parentId"
                    :options="dataList"
                    :normalizer="normalizer"
                    :show-count="false"
                    style="width: 90%"
                    placeholder="请选择父级分组，若不填写则默认为一级分组"
                    @select="handleParentChange"
        ></TreeSelect>
      </el-form-item>
      <el-form-item prop="label" label="分组名称">
        <el-input v-model="form.label"
                  :disabled="disabled"
                  style="width: 90%"
                  clearable
                  maxlength="10"
                  show-word-limit
                  placeholder="请输入分组名称"/>
      </el-form-item>
      <el-form-item prop="groupDesc" label="分组说明">
        <el-input type="textarea" v-model="form.groupDesc"
                  :disabled="disabled"
                  style="width: 90%"
                  maxlength="500"
                  placeholder="请输入分组说明"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 3}"/>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'CompSideTreeDetail',
  components: {TreeSelect},
  data() {
    return {
      disabled: false,
      parentNode: null,
      mode: 1,
      form: {
        id: null,
        parentId: "0",
        label: null,
        groupDesc: null,
      },
      rules: {
        label: [{required: true, message: '请输入分组名称', trigger: 'blur'}],
      }
    }
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Object,
      default: () => {
        return {
          children: 'children',
          label: 'label',
          maxLevel: 0,
        }
      }
    }
  },
  computed:{
    addMode() {
      return this.mode === 1;
    },
    editMode() {
      return this.mode === 2;
    }
  },
  methods: {
    normalizer(data) {
      return {
        id: data.id,
        label: data[this.options.label],
        children: data[this.options.children],
      }
    },

    /**
     * 选择事件 判断父节点是否到达最大层级
     *
     * @param pnode
     */
    handleParentChange(pnode) {
      this.parentNode = pnode;
      console.log("--------handleParentChange------->", pnode);
      if (this.options.maxLevel && this.options.maxLevel >= 0) {
        this.disabled = pnode.level >= this.options.maxLevel - 1;
        if (this.disabled) {
          this.$modal.msgError("已达到最大层级，请重新选择父级");
        }
      }
    },

    /**
     * 打开事件 判断父节点是否到达最大层级
     * @param opts
     */
    handleOpen(opts) {
      console.log("=====handleOpen opts====", opts);
      this.$refs.refForm.clearValidate();
      this.mode = opts.mode;
      let form = {};
      if(this.addMode) {// data父节点
        form.parentId = opts.data.id;
        this.form = form;
        if (this.options.maxLevel && this.options.maxLevel >= 0) {
          this.disabled = opts.data.level >= this.options.maxLevel - 1;
          if (this.disabled) {
            this.$modal.msgError("已达到最大层级，请重新选择父级");
          }
        }
      } else if(this.editMode) {
        form = {...opts.data};
        this.form = form;
      }
    },
    handleClose() {
      this.$refs.refForm.clearValidate();
      this.$refs.refForm.resetFields();
    },
    handleConfirm() {
      return new Promise((resolve, reject) => {
        if (this.disabled) {
          this.$modal.msgError("已达到最大层级，请重新选择父级");
          reject();
          return;
        }
        this.$refs.refForm.validate(valid => {
          if (valid) {
            if (!this.$util.isEmpty(this.form.parentId) && this.form.parentId !== '0' && this.form.id === this.form.parentId) {
              this.$modal.msgError(`节点[${this.form.label}]不能移动到自己节点下`);
              reject();
              return;
            }
            resolve(this.form);
          }
        })
      });
    }
  }
}
</script>

<style lang="less" scoped>

</style>